import React from 'react';
import "../customcss/errorpopup.css";


const ErrorPopup = ({ errors, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h3 className="popup-title">Oops! Something Went Wrong</h3>
        <ul className="error-list">
          {Object.keys(errors).map((field, index) => (
            errors[field] && <li key={index} className="error-item">{errors[field]}</li>
          ))}
        </ul>
        <div className="popup-footer">
          <button className="close-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
